module.exports = new __parcel__URL__("ticket-dispensor.f4a024b2.svg").toString();